<template>
  <div class="node-config fl p-l-20 border-box" :style="'width:' + width + ';height:' + height">
    <div class="bor-deep-gra bg-wh h-100p ovf-auto">
      <p class=" ft-bold p-t-20 p-b-20 m-t-0 m-b-0 m-l-30 m-r-30 bor-b-gray">配置项</p>
      <div class="p-t-20 p-l-30 p-r-30">
        <el-form ref="form" :model="curNode" :rules="rules" label-width="100px">
          <el-form-item label="节点名称" prop="name">
            <el-input v-model.trim="curNode.name" class="h-40 w-230"></el-input>
          </el-form-item>
          <el-form-item label="节点描述" prop="description" v-show="curNode.type != TYPE_REMARK">
            <el-input v-model.trim="curNode.description" type="textarea" class="w-230"></el-input>
          </el-form-item>
          <receiver-config
            title="接收方"
            :data="curNode"
            :users="users"
            :groups="groups"
            :structs="structs"
            :inputList="inputList"
            v-if="nodeMission || nodeApprove">
          </receiver-config>
          <form-block
            title="回退配置"
            v-if="nodeApprove">
            <el-form-item label="回退人配置">
              <el-radio-group v-model="curNode.rollback_config">
                <el-radio :label="10">上一级处理人</el-radio>
                <el-radio :label="20">发起人</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="回退字段名称">
              <el-input class="w-300" v-model="curNode.rollback_dialog_config.title"></el-input>
            </el-form-item>
            <el-form-item label="默认值">
              <el-input class="w-300" v-model="curNode.rollback_dialog_config.placeholder"></el-input>
            </el-form-item>
            <el-form-item label="是否必填">
              <el-radio-group v-model="curNode.rollback_dialog_config.allowEmpty">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </form-block>
          <form-block
            v-if="nodeMission || nodeApprove"
            title="知会配置">
            <receiver-config
              title="知会方"
              :data="curNode.notify_config"
              :users="users"
              :groups="groups"
              :structs="structs"
              :inputList="inputList"
              v-if="nodeMission || nodeApprove">
              <template slot="presentType">
                <el-radio :label="0">不知会</el-radio>
              </template>
              <el-form-item label="是否重置消息通知">
                <el-radio-group v-model="curNode.notify_config.is_reset_notify">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <template v-if="curNode.notify_config.is_reset_notify == 1">
                <el-form-item label="消息标题">
                  <el-input class="w-200" v-model="curNode.notify_config.msg_title"></el-input>
                </el-form-item>
                <el-form-item label="消息内容">
                  <el-input type="textarea" class="w-200" v-model="curNode.notify_config.msg_content"></el-input>
                </el-form-item>
              </template>
            </receiver-config>
          </form-block>
          <form-block
            title="审批历史配置"
            v-if="nodeApprove">
            <el-form-item label="通过字段名称">
              <el-input v-model="curNode.pass_dialog_config.title" class="w-300"></el-input>
            </el-form-item>
            <el-form-item label="默认值">
              <el-input v-model="curNode.pass_dialog_config.placeholder" class="w-300"></el-input>
            </el-form-item>
            <el-form-item label="是否必填">
              <el-radio-group v-model="curNode.pass_dialog_config.allowEmpty">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </form-block>
          <div v-show="nodeOnly">
            <div class="el-form-item__label">配置判断变量</div>
            <el-table :data="curNode.variable" style="width: 100%" class="m-b-20">
              <el-table-column label="操作" width="150px">
                <template scope="scope">
                  <el-button class="m-l-5" type="primary" size="mini" v-if="!scope.row.isClone" @click="cloneVar(scope.row, scope.$index)">+</el-button>
                  <el-button class="m-l-5" type="primary" size="mini" v-if="!scope.row.isClone" @click="sortVarUp(scope.row, scope.$index)">上移</el-button>
                  <el-button class="m-l-5" type="primary" size="mini" v-if="!scope.row.isClone" @click="sortVarDown(scope.row, scope.$index)">下移</el-button>
                  <el-button class="m-l-5" type="danger" size="mini" v-else @click="removeVar(scope.row, scope.$index)">-</el-button>
                </template>
              </el-table-column>
              <el-table-column label="流向" width="150px">
                <template scope="scope">
                  <span>{{ filterNodeName(scope.row.next_iden) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="默认流向" width="150px">
                <template scope="scope">
                  <el-radio-group v-model="scope.row.is_default" @change="resetIsDefault(scope.row, scope.$index)" v-if="!scope.row.isClone">
                    <el-radio :label="1">&nbsp;</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column label="选取变量" width="150px">
                <template scope="scope">
                  <el-select v-model="scope.row.field_id" placeholder="请选择判断变量">
                    <el-option v-for="item in inputList" :label="item.default.title" :value="item.default.field_id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="逻辑" prop="logic_type" width="150px">
                <template scope="scope">
                  <el-select v-model="scope.row.logic_type" placeholder="请选择判断逻辑">
                    <el-option v-for="item in logics" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="选取变量或值" width="150px">
                <template scope="scope">
                  <div class="el-input__inner pointer" style="line-height:28px" @click="showVar(scope.row)">{{ filterInputTitle(scope.row, scope.row.fixed_value) }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-form-item label="审批规则" prop="examine_rule" v-show="nodeApprove">
            <el-radio-group v-model="curNode.examine_rule">
              <el-radio :label="10">必须节点上所有审批人员审批方可通过</el-radio>
              <div class="m-b-10"></div>
              <el-radio :label="20">只需节点上任意一人审批即可通过</el-radio>
            </el-radio-group>
          </el-form-item> 
        </el-form>
      </div>
    </div>
    <!-- 选择变量弹窗 -->
    <el-dialog title="选择变量" v-model="varShow" size="tiny">
      <el-form>
        <el-form-item>
          <div class="inline-block w-100">
            <el-radio :label="10" v-model="curVar.value_type">固定值</el-radio>
          </div>
          <el-input v-model="tempVar.fixed_value" class="w-200" :disabled="curVar.value_type != 10"></el-input>
        </el-form-item>
        <el-form-item>
          <div class="inline-block w-100">
            <el-radio :label="20" v-model="curVar.value_type">变量</el-radio>
          </div>
          <el-select v-model="tempVar.field_id" :disabled="curVar.value_type != 20">
            <el-option v-for="item in inputList" :label="item.default.title" :value="item.default.field_id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="varShow = false">取 消</el-button>
        <el-button type="primary" @click="selectVar">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style scoped>
  .el-form-item {
    margin-bottom: 10px;
    padding: 0px; 
  }
  .tranParamsClass {
    color: #48576a;
  }
  .tranParamsClass .el-form-item__label{
    text-align: left;
    font-weight: 600;
  }
  .tranParamsClass .el-form-item__content {
    margin-left: 0px!important;
    clear: both;
  }
  .labelStyle {
    color: #222;
    font-size: 16px;
    margin-left: 48px;
  }
</style>
<style>
  .node-config .el-form-item {
    margin-left: 0 !important;
  }
</style>
<script>
import flowConfig from 'config/flowConfig'
import modelConfig from 'config/modelConfig'
import http from 'assets/js/http.js'
import receiverConfig from './receiverConfig'
import formBlock from 'components/Common/normal/formBlock'
export default {
  props: ['height', 'curNode', 'width', 'nodeList', 'routeList', 'inputList', 'users', 'posts', 'structs', 'groups'],
  data() {
    return {
      logics: [ // 逻辑数组
        { id: 10, name: '等于' },
        { id: 20, name: '不等于' },
        { id: 30, name: '大于' },
        { id: 40, name: '小于' },
        { id: 50, name: '小于等于' },
        { id: 60, name: '大于等于' },
        { id: 70, name: '不为' }
      ],
      relateNode: [], // 当前审批节点关联的节点
      varShow: false, // 显示选择变量弹窗
      tempVar: { // 临时变量
        field_id: '',
        fixed_value: ''
      },
      curVar: {},
      func_props: {
        label: 'title',
        value: 'name',
        children: 'functions'
      },
      paramTypeList: [
        { value: 10, title: '常量' },
        { value: 20, title: '变量' }
      ],
      returnParamLogicList: [
        { value: 10, title: '更新' },
        { value: 20, title: '忽略' }
      ],
      execution_funcList: [], // 执行参数列表
      // 当前选择的一级包名
      curFuncPackage: [],
      // 当前函数名
      function_name: []
      // isRealtionForigen: false,
      // relationForignList: [],
      // presentTypeOptions: [
      //   { id: 10, name: '固定接收人' },
      //   { id: 20, name: '选择接收部门' },
      //   { id: 40, name: '选择接收分组' },
      //   { id: 60, name: '选择关联字段' }
      // ]
    }
  },
  created() {
    // 初始化数据
    this.initData()
  },
  mixins: [modelConfig, flowConfig, http],
  methods: {
    initData() {
      // 初始化数据-执行参数列表
      this.apiGet('cms/contents/functions').then((res) => {
        if (res.code === 200) {
          if (res.data) {
            _(res.data).forEach((res) => {
              res.name = res.pakege_name
              delete res.pakege_name
            })
          }
          this.execution_funcList = res.data
        }
      })
    },
    // 获取当前审批节点相关的流转节点
    getRelateNode() {
      this.relateNode = []
      _(this.routeList).forEach((res) => {
        if (res.start_iden == this.curNode.iden) {
          let index = _.findIndex(this.nodeList, (item) => {
            return item.iden == res.end_iden
          })
          this.relateNode.push(this.nodeList[index])
        }
      })
    },
    examIdenChange() {
      this.curNode.examine = []
      this.curNode.examine.push({ examine_type: 10, iden: this.curNode.examine_iden })
      _(this.relateNode).forEach((res) => {
        if (res.iden != this.curNode.examine_iden) {
          this.curNode.examine.push({ examine_type: 20, iden: res.iden })
          return
        }
      })
    },
    // 显示选择变量或固定值弹窗
    showVar(item) {
      this.curVar = item
      // console.log('showVar', this.curVar)
      if (item.value_type == 10) {
        this.tempVar.fixed_value = item.fixed_value
        this.tempVar.field_id = 0
      } else if (item.value_type == 20) {
        this.tempVar.field_id = item.fixed_value
        this.tempVar.fixed_value = ''
      }
      this.varShow = true
    },
    // 变量判断网关 获取变量或固定值
    selectVar() {
      if (this.curVar.value_type == 10) {
        this.curVar.fixed_value = this.tempVar.fixed_value
      } else if (this.curVar.value_type == 20) {
        this.curVar.fixed_value = this.tempVar.field_id
      }
      this.varShow = false
    },
    // 克隆判断变量
    cloneVar(item, index) {
      let newVar = _.cloneDeep(item)
      newVar.field_id = ''
      newVar.fixed_value = ''
      newVar.logic_type = 10
      newVar.isClone = true
      this.curNode.variable.splice(index + 1, 0, newVar)
    },
    // 上移判断变量
    sortVarUp(item, index) {
      let firstKey = -1
      let targetArr = _.remove(this.curNode.variable, (res, key) => {
        if (firstKey == -1 && res.next_iden == item.next_iden) {
          firstKey = key
        }
        return res.next_iden == item.next_iden
      })
      if (firstKey == -1) {
        firstKey = 0
      }
      let firstVarIden = ''
      let insertIndex = firstKey
      for (let i = firstKey - 1; i >= 0; i--) {
        if (!firstVarIden) {
          firstVarIden = this.curNode.variable[i].next_iden
        } else if (firstVarIden != this.curNode.variable[i].next_iden) {
          break
        }
        insertIndex--
      }
      let frontArr = this.curNode.variable.slice(0, insertIndex)
      let endArr = this.curNode.variable.slice(insertIndex, this.curNode.variable.length)
      this.curNode.variable = [...frontArr, ...targetArr, ...endArr]
    },
    // 下移判断变量
    sortVarDown(item, index) {
      let firstKey = -1
      let targetArr = _.remove(this.curNode.variable, (res, key) => {
        if (firstKey == -1 && res.next_iden == item.next_iden) {
          firstKey = key
        }
        return res.next_iden == item.next_iden
      })
      if (firstKey == -1) {
        firstKey = 0
      }
      let firstVarIden = ''
      let insertIndex = firstKey
      for (let i = firstKey; i < this.curNode.variable.length; i++) {
        if (!firstVarIden) {
          firstVarIden = this.curNode.variable[i].next_iden
        } else if (firstVarIden != this.curNode.variable[i].next_iden) {
          break
        }
        insertIndex++
      }
      let frontArr = this.curNode.variable.slice(0, insertIndex)
      let endArr = this.curNode.variable.slice(insertIndex, this.curNode.variable.length)
      this.curNode.variable = [...frontArr, ...targetArr, ...endArr]
    },
    // 删除克隆的判断变量
    removeVar(item, index) {
      this.curNode.variable.splice(index, 1)
    },
    // 重置选中的默认流向
    resetIsDefault(item, index) {
      if (!item.is_default) {
        return
      }
      _(this.curNode.variable).forEach((res, key) => {
        if (res.is_default && key != index) {
          res.is_default = 0
          return
        }
      })
    },
    // 设置克隆标识
    setCloneMark() {
      let iden = ''
      _(this.curNode.variable).forEach((res) => {
        if (!iden) {
          iden = res.next_iden
        } else if (iden != res.next_iden) {
          iden = res.next_iden
        } else if (iden == res.next_iden) {
          res.isClone = true
        }
      })
    },
    // 根据节点id获取节点名
    filterNodeName(value) {
      if (!value) {
        return ''
      }
      let index = _.findIndex(this.nodeList, (res) => {
        return res.iden == value
      })
      return index != -1 ? this.nodeList[index].name : ''
    },
    // 根据控件id获取控件名称
    filterInputTitle(item, value) {
      if (!value) {
        return ''
      }
      if (item.value_type != 20) { // 非变量
        return value
      }
      let index = _.findIndex(this.inputList, (res) => {
        return res.default.field_id == value
      })
      return index != -1 ? this.inputList[index].default.title : ''
    },
    // 父级发生变化时选择事件
    func_pageNameChange(curArr) {
      // console.log('func_pageNameChange', curArr)
      this.curNode.functions.package_name = curArr[0]
      if (curArr.length === 0) {
        this.curFuncPackage = []
        return
      }
      // 根据当前选择包名 找到对应的数组位置下标
      let curIndex = _.findIndex(this.execution_funcList, (item) => {
        return curArr[0] === item.name
      })
      this.curFuncPackage = this.execution_funcList[curIndex]
    },
    // 选择函数改变事件
    func_Change(curValue) {
      // console.log('func_Change', curValue)
      this.curNode.functions.function_name = curValue[curValue.length - 1]
      if (curValue.length === 0) {
        this.function_name = null
        this.curNode.functions.params = []
        this.curNode.functions.return_params = []
        return
      }
      // 根据当前选择name 找到对应的数组位置下标
      this.function_name = curValue[curValue.length - 1]
      let curIndex = _.findIndex(this.curFuncPackage.functions, (item) => {
        return item.name === this.function_name
      })
      // 获取传入参数
      this.curNode.functions.params = []
      let tempArray = this.curFuncPackage.functions[curIndex].param
      _(tempArray).forEach((item) => {
        this.curNode.functions.params.push({
          name: item.title,
          type: 10,
          value: null
        })
      })
      this.$set(this.curNode.functions, 'params', this.curNode.functions.params)
      // 获取返回参数
      this.curNode.functions.return_params = []
      let tempArrayA = this.curFuncPackage.functions[curIndex].return_param
      _(tempArrayA).forEach((item) => {
        this.curNode.functions.return_params.push({
          name: item.title,
          type: 10,
          value: null
        })
      })
      // console.log("this.curNode", this.curNode)
    }
    // relationChange(id) { // 本表字段选择
    //   this.isRealtionForigen = false
    //   if (!id) {
    //     return
    //   }
    //   _(this.inputList).forEach((item) => {
    //     if (item.default.field_id === id && item.default.type === this.TYPE_FOREIGNKEY) {
    //       this.isRealtionForigen = true
    //       return false
    //     }
    //   })
    //   if (this.isRealtionForigen) {
    //     // 请求外键关联的表字段
    //     this.relationForignList = []
    //     this.apiGet(`cms/deals/foreign_fields/${id}`).then((res) => {
    //       if (res.code === 200) {
    //         this.relationForignList = res.data
    //       }
    //     })
    //   }
    // }
  },
  watch: {
    curNode() {
      if (this.curNode.type == this.TYPE_ONLY) {
        this.setCloneMark()
      }
      // console.log("this.curNode-watch", this.curNode)
    }
  },
  computed: {
    nodeMission() { // 节点类型为任务
      return this.curNode.type == this.TYPE_MISSION
    },
    nodeApprove() { // 节点类型为审批
      return this.curNode.type == this.TYPE_APPROVE
    },
    nodeOnly() { // 节点类型为排他
      return this.curNode.type == this.TYPE_ONLY
    },
    nodeFunc() { // 节点类型为执行函数
      return this.curNode.type == this.TYPE_FUNC
    }
    // receiveTypePerson() { // 接收类型为接收人
    //   return this.curNode.present_type == this.RECEIVE_PERSON
    // },
    // receiveTypeStruct() { // 接收类型为接收部门
    //   return this.curNode.present_type == this.RECEIVE_STRUCT
    // },
    // receiveTypeRelation() { // 接收类型为关联字段
    //   if (this.curNode.related_field_config.field_id) {
    //     this.relationChange(this.curNode.related_field_config.field_id)
    //   }
    //   return this.curNode.present_type == this.RECEIVE_RELATION
    // },
    // receiveTypeGroup() { // 接受类型为接收分组
    //   return this.curNode.present_type == this.RECEIVE_GROUP
    // },
    // receiveTypePost() { // 接收类型为接收岗位
    //   return this.curNode.present_type == this.RECEIVE_POST
    // },
    // receiveTypeAll() {  // 接收类型为全部
    //   return this.curNode.present_type == this.RECEIVE_All
    // },
    // typePersonSelf() {  // 自定义接收人
    //   return this.curNode.receive_user.free_status == 1
    // }
  },
  components: {
    receiverConfig,
    formBlock
  }
}
</script>


// WEBPACK FOOTER //
// nodeConfig.vue?2cf30020